import BonusCalculator from "kinnect-front/Bonus/BonusCalculator";
import DefaultLayout from "@/layouts/DefaultLayout";
import { Bonus } from "kinnect-models";
import { FetchesData, Pageable } from "kinnect-mixins";
import {
	VCard,
	VCardText,
	VCardTitle,
	VIcon,
	VList,
	VListItem,
	VListItemAvatar,
	VListItemContent,
	VListItemSubtitle,
	VListItemTitle,
	VSpacer
} from "vuetify/lib";
import { formatCurrency, formatDate } from "kinnect-formatters";

export default {
	name: "BonusPage",

	metaInfo: { title: "Bonus" },

	mixins: [
		FetchesData,
		Pageable
	],

	data: () => ( {
		bonus: {}
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "edit_bonus" ) ) {
				return {
					icon: "add_circle",
					text: "Edit Bonus",
					to: { name: "bonusEdit" }
				};
			}
		}
	},

	methods: {
		async fetchBonus() {
			this.bonus = await Bonus.first();
		},

		async fetch() {
			await this.fetchBonus();
		}
	},

	render() {
		if ( !this.fetched ) {
			return;
		}

		return <DefaultLayout>
			<VCard class="mb-4">
				<VCardTitle class="primary white--text">
					Company Bonus
				</VCardTitle>

				<VSpacer></VSpacer>

				<VCardText>
					<VList>
						<VListItem>
							<VListItemAvatar>
								<VIcon>attach_money</VIcon>
							</VListItemAvatar>

							<VListItemContent>
								<VListItemTitle>
									Point Value
								</VListItemTitle>

								<VListItemSubtitle>
									{this.bonus.pointValue
										? formatCurrency( this.bonus.pointValue )
										: "--"
									}
								</VListItemSubtitle>
							</VListItemContent>
						</VListItem>

						<VListItem>
							<VListItemAvatar>
								<VIcon>event</VIcon>
							</VListItemAvatar>

							<VListItemContent>
								<VListItemTitle>
									Last Updated
								</VListItemTitle>

								<VListItemSubtitle>
									{this.bonus.asOfDate
										? formatDate( this.bonus.asOfDate, "MMMM do, yyyy" )
										: "--"
									}
								</VListItemSubtitle>
							</VListItemContent>
						</VListItem>
					</VList>
				</VCardText>
			</VCard>

			<BonusCalculator pointValue={this.bonus.pointValue}></BonusCalculator>
		</DefaultLayout>;
	}
};
